"use client";

import Script from "next/script";

/** kolaytik (JotForm) demo talep formu */
const FORM_ID = "261882444777067";
const FORM_BASE = "https://panel.kolaytik.com";
const IFRAME_ID = `JotFormIFrame-${FORM_ID}`;

declare global {
  interface Window {
    jotformEmbedHandler?: (selector: string, baseUrl: string) => void;
  }
}

/**
 * Formu iframe olarak gömer; embed handler iframe yüksekliğini içeriğe göre
 * otomatik ayarlar (539px yalnızca ilk değerdir).
 *
 * Not: JotForm'un varsayılan `onload="window.parent.scrollTo(0,0)"` davranışı
 * bilinçli olarak eklenmedi — sayfayı form yüklenince başa sıçratıyor.
 */
export function DemoFormEmbed({ title }: { title: string }) {
  return (
    <>
      <iframe
        id={IFRAME_ID}
        title={title}
        src={`${FORM_BASE}/${FORM_ID}`}
        allow="geolocation; microphone; camera; fullscreen; payment"
        scrolling="no"
        style={{
          display: "block",
          width: "100%",
          height: 539,
          border: "none",
        }}
      />
      <Script
        src={`${FORM_BASE}/s/umd/latest/for-form-embed-handler.js`}
        strategy="afterInteractive"
        onLoad={() => {
          window.jotformEmbedHandler?.(`iframe[id='${IFRAME_ID}']`, FORM_BASE);
        }}
      />
    </>
  );
}
